import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { useLDClient, withLDProvider } from "launchdarkly-react-client-sdk";
import { compose, composeDataMethods, wrapHOCWithOptions } from "@lululemon/mwa-utils";
import { publicConfig } from "@lululemon/ecom-common/src/util/public-config";
import { useDeviceType } from "./with-device-characteristics";
var ref;
function deviceTypeObjToStr(deviceType) {
    if (deviceType.isDesktop) {
        return "desktop";
    }
    if (deviceType.isMobile) {
        return "mobile";
    }
    if (deviceType.isTablet) {
        return "tablet";
    }
    return "unknown";
}
var withLDContextUpdates = function(Component) {
    var WithLDContextUpdates = function WithLDContextUpdates(_param) {
        var nextLocale = _param.nextLocale, props = _object_without_properties(_param, [
            "nextLocale"
        ]);
        var deviceType = useDeviceType().deviceType;
        var deviceTypeStr = deviceTypeObjToStr(deviceType);
        var ref = _sliced_to_array(nextLocale === null || nextLocale === void 0 ? void 0 : nextLocale.split("-"), 2), language = ref[0], country = ref[1];
        var ldClient = useLDClient();
        React.useEffect(function() {
            if (ldClient) {
                ldClient.identify({
                    kind: "multi",
                    user: {
                        key: "aLkdYinjkPdslfk4223ad"
                    },
                    country: {
                        key: country.toUpperCase()
                    },
                    language: {
                        key: language.toUpperCase()
                    },
                    deviceType: {
                        key: deviceTypeStr
                    }
                });
            }
        }, [
            country,
            deviceTypeStr,
            language,
            ldClient
        ]);
        return /*#__PURE__*/ _jsx(Component, _object_spread({}, props));
    };
    return composeDataMethods(Component, {
        getInitialProps: function(param) {
            var ctx = param.ctx;
            return {
                nextLocale: ctx.nextLocale
            };
        }
    })(WithLDContextUpdates);
};
export { withLDContextUpdates };
export var withLaunchDarkly = compose(wrapHOCWithOptions(withLDProvider)({
    clientSideID: publicConfig === null || publicConfig === void 0 ? void 0 : (ref = publicConfig.launchDarkly) === null || ref === void 0 ? void 0 : ref.clientSideId,
    context: {
        kind: "multi",
        user: {
            key: "aLkdYinjkPdslfk4223ad"
        }
    }
}), withLDContextUpdates);
